import type { StrategyField, StrategyFields } from '@/App/tiles/Option/strategy/types.ts';

/** Grouped vertical fields start at row 3, after the expiry-group row and leg headers. */
export function getFieldRow(fields: StrategyFields, index: number): number {
  return 3 + fields.slice(0, index).reduce((total, field) => total + getFieldSpan(field), 0);
}

/** Field arrays reserve an extra row so their vertical wrapper can center the grouped fields. */
export function getFieldSpan(field: StrategyField | StrategyField[]): number {
  return Array.isArray(field) ? field.length + 1 : 1;
}

/** Shared hedge slots only; premiumDate remains a pricing field, not a shared hedge editor. */
export function isHedgeField(field: StrategyField): boolean {
  return field === 'hedgeRate' || field === 'hedgeAmount' || field === 'hedgeDate';
}
